exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".uu5-bricks-camera {\n  background-color: #666;\n}\n.uu5-bricks-camera-video {\n  display: block;\n  width: 100%;\n}\n.uu5-bricks-camera-canvas {\n  display: none;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/less-loader/dist!./bricks/camera.less
// module id = 194
// module chunks = 0